import { Progress } from "antd";
import { useNavigate } from "react-router-dom";
import { useHeader } from "../contexts/HeaderContext";
import { stepLabel, stepStatusLabel } from "../viewLabels";

import styles from "./ProgressBar.module.css";

const ProgressBar = () => {
    const { progress, journey, currentStepId } = useHeader();
    const navigate = useNavigate();

    if (!progress) return null;

    return (
        <div className={styles.outerContainer}>
            {progress.type === "linear" ? (
                <Progress
                    percent={progress.percent}
                    percentPosition={{ align: "end", type: "inner" }}
                    size={["30vw", 20]}
                    strokeColor="var(--brand)"
                    status="active"
                />
            ) : (
                <div className={styles.stepWrapper}>
                    {progress.steps.map((step, i) => {
                        const isLivePosition = step.state === "current";
                        const isBeingReviewed =
                            currentStepId != null && step.step_id === currentStepId;
                        const isCurrent = isLivePosition || isBeingReviewed;
                        const openable = step.state === "completed" || step.state === "traced";
                        const label = step.step_type
                            ? `${stepLabel(step.step_type)} · ${stepStatusLabel(step.state)}`
                            : undefined;

                        const destination = isBeingReviewed
                            ? null
                            : openable
                                ? `/t/${journey?.id}/step/${step.step_id}`
                                : isLivePosition && currentStepId != null
                                    ? `/t/${journey?.id}`
                                    : null;

                        return (
                            <button
                                key={i}
                                type="button"
                                className={[
                                    styles.dot,
                                    styles[`type-${step.step_type}`],
                                    openable ? styles.done : styles.upcoming,
                                    isCurrent ? styles.current : "",
                                ].join(" ")}
                                disabled={!destination}
                                title={label}
                                aria-label={label}
                                onClick={() => destination && navigate(destination)}
                            >
                                <span className={styles.stepDot} />
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
}

export default ProgressBar;